var map = {
	"./ArrowDown_34x34.svg": "./src/images/ArrowDown_34x34.svg",
	"./ArrowLeft.svg": "./src/images/ArrowLeft.svg",
	"./ArrowRight.svg": "./src/images/ArrowRight.svg",
	"./Arrow_downGREY_10x10.svg": "./src/images/Arrow_downGREY_10x10.svg",
	"./ChangeCamera.svg": "./src/images/ChangeCamera.svg",
	"./ChooseFile.svg": "./src/images/ChooseFile.svg",
	"./Clear.svg": "./src/images/Clear.svg",
	"./CloseCamera.svg": "./src/images/CloseCamera.svg",
	"./DefaultFile.svg": "./src/images/DefaultFile.svg",
	"./Delete.svg": "./src/images/Delete.svg",
	"./Down_34x34.svg": "./src/images/Down_34x34.svg",
	"./Left.svg": "./src/images/Left.svg",
	"./ModernBooleanCheckChecked.svg": "./src/images/ModernBooleanCheckChecked.svg",
	"./ModernBooleanCheckInd.svg": "./src/images/ModernBooleanCheckInd.svg",
	"./ModernBooleanCheckUnchecked.svg": "./src/images/ModernBooleanCheckUnchecked.svg",
	"./ModernCheck.svg": "./src/images/ModernCheck.svg",
	"./ModernRadio.svg": "./src/images/ModernRadio.svg",
	"./More.svg": "./src/images/More.svg",
	"./NavMenu_24x24.svg": "./src/images/NavMenu_24x24.svg",
	"./ProgressButton.svg": "./src/images/ProgressButton.svg",
	"./ProgressButtonV2.svg": "./src/images/ProgressButtonV2.svg",
	"./RemoveFile.svg": "./src/images/RemoveFile.svg",
	"./Right.svg": "./src/images/Right.svg",
	"./SearchClear.svg": "./src/images/SearchClear.svg",
	"./ShowCamera.svg": "./src/images/ShowCamera.svg",
	"./TakePicture.svg": "./src/images/TakePicture.svg",
	"./TakePicture_24x24.svg": "./src/images/TakePicture_24x24.svg",
	"./TimerCircle.svg": "./src/images/TimerCircle.svg",
	"./V2Check.svg": "./src/images/V2Check.svg",
	"./V2Check_24x24.svg": "./src/images/V2Check_24x24.svg",
	"./V2DragElement_16x16.svg": "./src/images/V2DragElement_16x16.svg",
	"./chevron.svg": "./src/images/chevron.svg",
	"./clear_16x16.svg": "./src/images/clear_16x16.svg",
	"./collapseDetail.svg": "./src/images/collapseDetail.svg",
	"./expandDetail.svg": "./src/images/expandDetail.svg",
	"./loading.svg": "./src/images/loading.svg",
	"./no-image.svg": "./src/images/no-image.svg",
	"./rating-star-2.svg": "./src/images/rating-star-2.svg",
	"./rating-star-small-2.svg": "./src/images/rating-star-small-2.svg",
	"./rating-star-small.svg": "./src/images/rating-star-small.svg",
	"./rating-star.svg": "./src/images/rating-star.svg",
	"./search.svg": "./src/images/search.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/images sync \\.svg$";